import "core-js/modules/es.object.assign.js";
import { radar } from './_weblogger';
/**
 * 雷达自定义上报事件 name是必传的，其他参数根据实际需求传递
 * e.g：在白屏错误上报里，需要传递event_type、result_type、message
 *
 * @param name 必填
 * @param options
 */
var sendCustomRadarEvent = function sendCustomRadarEvent(name, options, extraOptions) {
  radar && radar.event(Object.assign({
    name: name
  }, options), extraOptions);
};

// fmp上报
function sendFMPTimestamp(timeStamp) {
  radar && radar.fmp(timeStamp);
}

// 上报用户sso 过期，重新登陆的情况 name: 'REDIRECT_SSO'
var sendCustomLoginRedirect = function sendCustomLoginRedirect(options) {
  sendCustomRadarEvent('REDIRECT_SSO', Object.assign({
    event_type: 'sso_login'
  }, options));
};

// 雷达捕获错误&上报
var sendCustomErrorEvent = function sendCustomErrorEvent(name, options, error) {
  radar && radar.captureException(error);
  sendCustomRadarEvent(name, options);
};

// 渲染耗时
var renderTimeConsuming = function renderTimeConsuming(eventType, duration) {
  sendCustomRadarEvent('RENDER_TIME_CONSUMING', {
    event_type: eventType
  }, {
    duration: duration
  });
};
export { sendCustomRadarEvent, sendFMPTimestamp, sendCustomLoginRedirect, sendCustomErrorEvent, renderTimeConsuming };